<template>
    <div>
        <creditSummaryCustomer v-show="tab == 'customer'" ref="creditSummaryCustomer" @setBalanceSummary="setBalanceSummary" @setExportData="setExportData"></creditSummaryCustomer>
        <creditSummaryDate v-show="tab == 'date'" ref="creditSummaryDate" @setSummary="setSummary" @setExportData="setExportData"></creditSummaryDate>
    </div>
</template>
<script>
import CreditSummaryDate from './Credit_Summary_Date'
import CreditSummaryCustomer from './Credit_Summary_Customer'
export default {
    name: "creditSummary",
    data(){
        return{
            tab: "customer",
        }
    },
    components:{
        CreditSummaryDate, CreditSummaryCustomer
    },
    methods:{
        async handleCreditSummary(filterObj){
            this.tab = filterObj.summaryType
            if(this.tab == 'date'){
                this.$refs.creditSummaryDate.setCreditSummary(filterObj);
            }else{
                await this.$refs.creditSummaryCustomer.setCreditSummaryCustomer(filterObj);
            }
        }, 
        setSummary(data){
            this.$emit('setSummary', data)
        },
        setBalanceSummary(total){
            this.$emit('setBalanceSummary', total)
        },
        setExportData(data){
            this.$emit('setExportData', data)
        }
    }
}
</script>
